module.exports = __webpack_public_path__ + "static/media/10.a6163df1.jpeg";